import { render, staticRenderFns } from "./ZgbTeamMembersModify.vue?vue&type=template&id=22db62d9"
import script from "./ZgbTeamMembersModify.vue?vue&type=script&lang=js"
export * from "./ZgbTeamMembersModify.vue?vue&type=script&lang=js"
import style0 from "./ZgbTeamMembersModify.vue?vue&type=style&index=0&id=22db62d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports